import { render, staticRenderFns } from "./CourseCardSpecialization.vue?vue&type=template&id=447436ca"
import script from "./CourseCardSpecialization.vue?vue&type=script&lang=js"
export * from "./CourseCardSpecialization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
